import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-137f17b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "panel-con" }

import { ref, onMounted, computed, watch, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Login from '@/components/Login/index.vue'
import ContactModal from './components/ContactModal.vue'
import { setViewPort, Plat } from './util'
import { isJA } from '@/store'
import { PlatProps, getD2dUrl } from '@/common/const'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

_useCssVars(_ctx => ({
  "f286b6ee": (logoUrl.value)
}))

const route = useRoute()
const { query } = route

const store = useStore()
const defaultImageUrl = window.location.href.includes('from') && query.from !== 'ckbh5' ? 'https://static-s.theckb.com/BusinessMarket/Easy/H5/3Fbox.png' : 'https://static-jp.theckb.com/static-asset/client/sign_up_logo_h5_ja_v4.png'
const defaultLogoUrl = window.location.href.includes('from') && query.from !== 'ckbh5' ? 'url(https://static-s.theckb.com/BusinessMarket/Easy/H5/3Fbox.png)' : 'url(https://static-jp.theckb.com/static-asset/client/sign_up_logo_h5_ja_v4.png)'
const bgImageUrl = ref(defaultImageUrl)
const logoUrl = ref(defaultLogoUrl)

const site = computed(() => store.getters.site)

watch(
  () => site.value,
  async (site: 'ko' | 'ja' | 'en') => {
    switch (site) {
      case 'ko':
        bgImageUrl.value = 'https://static-s.theckb.com/BusinessMarket/Client/loginLogo-ko.png'
        break
      case 'ja':
        bgImageUrl.value = defaultImageUrl
        break
      case 'en':
        bgImageUrl.value = 'https://static-jp.theckb.com/static-asset/client/loginLogo.png'
        break
      default:
        break
    }
  }, {
    immediate: true
  }
)

onUnmounted(() => {
  setViewPort(Plat.pc)
})

onMounted(() => {
  setViewPort(Plat.h5)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "login_h5",
    class: _normalizeClass([_unref(isJA)() ? 'japanese' : '', "rel"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`logo flex-cen ${_unref(isJA)() ? 'hidden' : ''}`)
    }, [
      _createElementVNode("img", {
        class: "logoImg",
        src: bgImageUrl.value,
        alt: ""
      }, null, 8, _hoisted_1)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Login, { h5: true })
      ])
    ]),
    _createVNode(ContactModal),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          "enter-active-class": "animated fadeIn",
          "leave-active-class": "animated fadeOut"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ], 2))
}
}

})